import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { ITask, ITaskPayload } from '../Tasks.ts';
import { patientStore } from '../../../Store/Store.ts';

export function usePostTaskMutations() {
    const queryClient = useQueryClient();
    const patientId = patientStore.patientId;

    return useMutation<ITask, AppMedError, ITaskPayload>({
        mutationKey: [QueryKeys.tasks],
        mutationFn: async (variables: ITaskPayload) => {
            const responseId = await TasksApi.postTasks(variables);
            return {
                ...variables,
                id: responseId,
            } as ITask;
        },
        onSuccess: (data: ITask) => {
            queryClient.setQueryData<ITask[]>([QueryKeys.tasks], (prev) => {
                return prev ? [...prev, data] : [data];
            });
            if (patientId) {
                queryClient.setQueryData<ITask[]>([QueryKeys.tasks, patientId], (prev) => {
                    return prev ? [...prev, data] : [data];
                });
            }
            // Tasks (questionnaire / counsellingAcknowledgement) link to clinical notes;
            // invalidate so Physical Exam / Medical History / Counselling tabs show the new task without a refresh.
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNotes] });
        },
    });
}
